import { render, staticRenderFns } from "./Tech.vue?vue&type=template&id=6b3cfd9c"
import script from "./Tech.vue?vue&type=script&lang=js"
export * from "./Tech.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports